import { val } from '../utils/features';

// Renderiza el valor de una celda del panel SG. El registro de features (`utils/features.js`) es
// .js y no puede construir JSX, así que las celdas con formato devuelven un OBJETO-MARCADOR que se
// pinta acá. Un valor plano (string/número) pasa por `val` como siempre.
//   { __badge, tone } → píldora de color (estado de la palpación)
//   { __note, title } → texto con tooltip (nombre resuelto de forma APROXIMADA)
// El texto plano de un marcador (para atributos `title`) sale de `valueText` en utils/features.
export default function SgValue({ value }) {
    if (value && typeof value === 'object') {
        if (value.__badge !== undefined) {
            return <span className={`sg-badge sg-badge--${value.tone || 'neutral'}`}>{value.__badge}</span>;
        }
        if (value.__note !== undefined) {
            return <span className="sg-note" title={value.title}>{value.__note}</span>;
        }
    }
    return val(value);
}
